module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contain"
  }, [_c('div', {
    staticClass: "sfz-pic"
  }, [_vm._v("\n    身份证识别(拍照/照片)\n    "), _c('input', {
    ref: "picInput",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.uploadPic
    }
  })]), _vm._v(" "), (_vm.loadding) ? _c('div', {
    staticClass: "mask"
  }, [_c('van-loading', {
    attrs: {
      "type": "spinner",
      "color": "white"
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0bad226","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/picker/IdCardPicker.vue
// module id = 1564
// module chunks = 0